export interface AccountingPeriod {
  cost: number;
  price: number;
  profit: number;
  charge_count: number;
}

export interface ProviderRow {
  provider: string;
  cost: number;
  price: number;
  count: number;
}

export interface TopUserRow {
  user_id: string;
  spend: number;
  cost: number;
  charge_count: number;
}

export interface FreeVsPaid {
  free_count: number;
  paid_count: number;
  total: number;
  free_pct: number;
  paid_pct: number;
}

export interface CreditsStats {
  issued_usd: number;
  spent_usd: number;
  total_balance_usd: number;
}

export interface AccountingSummary {
  today: AccountingPeriod;
  month: AccountingPeriod;
  by_provider: ProviderRow[];
  top_users: TopUserRow[];
  free_vs_paid: FreeVsPaid;
  credits: CreditsStats;
  error?: string;
}

export async function fetchAccountingSummary(): Promise<AccountingSummary> {
  const r = await fetch("/api/accounting/summary", { cache: "no-store" });
  if (!r.ok) throw new Error(`accounting/summary HTTP ${r.status}`);
  return r.json();
}

function fmtUsd(v: number): string {
  if (Math.abs(v) >= 1) return `$${v.toFixed(3)}`;
  if (Math.abs(v) >= 0.01) return `$${v.toFixed(4)}`;
  return `$${v.toFixed(6)}`;
}

export { fmtUsd };
